import React, { useEffect } from 'react';
import { useWhiteLabelConfig } from '@cyberint/common-utils';
import { useRouteTitle } from '../../hooks/useRouteTitle';
import { t } from '../../i18n';

export const BulletinBoardTitle = ({ match }) => {
  const { title, setTitle } = useRouteTitle(match);
  const { whiteLabelConfig } = useWhiteLabelConfig();

  useEffect(() => {
    setTitle(t('common.bulletinBoard', { companyName: whiteLabelConfig.name }));
  }, [whiteLabelConfig]);

  return <span>{title}</span>;
};
